module.exports = __webpack_public_path__ + "static/media/contact.00365edc.svg";